import React from 'react';
import cs from 'clsx';
import styles from './Text.scss';
export const Text = _ref => {
  let children = _ref.children,
    className = _ref.className,
    dataHook = _ref.dataHook,
    size = _ref.size,
    skin = _ref.skin,
    ellipsis = _ref.ellipsis,
    light = _ref.light,
    lineHeight = _ref.lineHeight,
    style = _ref.style,
    weight = _ref.weight;
  const customWeight = weight != null && !['bold', 'thin'].includes(weight);
  const customSize = size != null && !['small', 'medium', 'tiny', 'large'].includes(size);
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHook,
    className: cs(styles.text, className, {
      [styles.light]: light,
      [styles.tiny]: size === 'tiny',
      [styles.medium]: size === 'medium',
      [styles.large]: size === 'large',
      [styles.bold]: weight === 'bold',
      [styles.thin]: weight === 'thin',
      [styles.ellipsis]: ellipsis,
      [styles.primary]: skin === 'primary',
      [styles.standard]: skin === 'standard',
      [styles.error]: skin === 'error',
      [styles.disabled]: skin === 'disabled',
      [styles.premium]: skin === 'premium',
      [styles.success]: skin === 'success'
    }),
    style: {
      fontWeight: customWeight ? weight : undefined,
      fontSize: customSize ? size : undefined,
      lineHeight,
      ...style
    }
  }, children);
};
//# sourceMappingURL=Text.js.map